/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Paper,
  TextField,
  Button,
  Autocomplete,
  Checkbox,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import dayjs from 'dayjs';
import api from '../utils/functions/api';
import { getStorage } from '../utils/functions/localstorage';
import TablePendingSuperAdmin from '../components/TablePendingSuperAdmin';
import Loading from '../components/Loading';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function PendingSuperAdmin() {
  const [ispendingSuperAdmin, setISpendingSuperAdmin] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [startDateFilter, setStartDateFilter] = useState(
    dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
  );
  const [endDateFilter, setEndDateFilter] = useState(
    dayjs().format('YYYY-MM-DD HH:mm:ss'),
  );
  const [orderDirection, setOrderDirection] = useState('asc');
  const [valueToOrderBy, setValueToOrderBy] = useState('');
  const [pagination, setPagination] = useState({
    currPage: 1,
    size: 10,
    lastPage: 1,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMerchants, setSelectedMerchants] = useState([]);
  const [merchOpt, setMerchOpt] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchMerchants = async () => {
    try {
      const path = `${process.env.REACT_APP_APIHOST}/company/data/all`;
      const { data } = await api.get(path, {
        headers: { Authorization: getStorage('token') },
      });
      setMerchOpt(data.filter((merchant) => merchant.name));
    } catch (e) {
      throw new Error(e);
    }
  };

  const getUploadLists = async () => {
    try {
      setIsLoading(true);
      const path = `${process.env.REACT_APP_APIHOST}/banktransfer/pending?sort_by=${valueToOrderBy}&order=${orderDirection}`;
      const { data } = await api.get(path, {});
      // let allCompanyData = [];
      // data.companies.forEach((company) => {
      //   const companyDataWithNames = company.data.map((item) => {
      //     return { ...item, company_name: company.company_name };
      //   });
      //   allCompanyData = allCompanyData.concat(companyDataWithNames);
      // });
      setISpendingSuperAdmin(data.data);
      setFilteredData(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.data ? data.data.length : 0, // Use data.data.length
        lastPage: data.data ? Math.ceil(data.data.length / pagination.size) : 1, // Calculate lastPage correctly
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    getUploadLists();
    fetchMerchants();
  }, [valueToOrderBy, orderDirection]);

  const handleMerchantChange = (event, newValueMerchant) => {
    if (newValueMerchant) {
      const newMerchantIds = newValueMerchant.map(
        (option) => option.key_cashier,
      );
      setSelectedMerchants(newMerchantIds);
    } else {
      setSelectedMerchants([]);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAscending = valueToOrderBy === property && orderDirection === 'asc';
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? 'desc' : 'asc');
  };

  const handlePaginationChange = (event, value) => {
    if (event === 'handleChangePage') {
      setPagination((prev) => ({ ...prev, currPage: value }));
    } else {
      setPagination((prev) => ({ ...prev, currPage: 1, size: value }));
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const onClickSubmit = async () => {
    try {
      setIsLoading(true);
      const merchantFilter = selectedMerchants.join(',');
      const path = `${
        process.env.REACT_APP_APIHOST
      }/banktransfer/pending?mkeyfilter=${merchantFilter}&search=${encodeURIComponent(
        searchQuery,
      )}`;
      const { data } = await api.get(path, {});
      // let allCompanyData = [];
      // data.companies.forEach((company) => {
      //   const companyDataWithNames = company.data.map((item) => {
      //     return { ...item, company_name: company.company_name };
      //   });
      //   allCompanyData = allCompanyData.concat(companyDataWithNames);
      // });
      setISpendingSuperAdmin(data.data);
      setFilteredData(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.data ? data.data.length : 0, // Use data.data.length
        lastPage: data.data ? Math.ceil(data.data.length / pagination.size) : 1, // Calculate lastPage correctly
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  const onClickCancel = () => {
    setSelectedMerchants([]);
    setStartDateFilter(dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'));
    setEndDateFilter(dayjs().format('YYYY-MM-DD HH:mm:ss'));
    setSearchQuery('');
    setPagination({ currPage: 1, size: 10, lastPage: 1, total: 0 });
    getUploadLists();
    window.location.reload();
  };

  const renderFilterFormPendingSuperAdmin = () => (
    <form>
      <Grid container spacing={3} style={{ marginTop: '8px' }}>
        <Grid container item spacing={3} xs={12}>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              size="small"
              options={merchOpt.filter((merchant) => merchant.name)}
              disableCloseOnSelect
              getOptionLabel={(option) => `${option.name}`}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name}
                </li>
              )}
              onChange={handleMerchantChange}
              value={merchOpt.filter((option) =>
                selectedMerchants.includes(option.key_cashier),
              )}
              renderInput={(params) => (
                <TextField {...params} label="ค้นหาร้านค้า :" fullWidth />
              )}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            <TextField
              className="text"
              label="ค้นหาข้อความ :"
              variant="outlined"
              size="small"
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={onClickSubmit}
            variant="outlined"
            color="success"
            size="medium"
            style={{ marginLeft: '20px', marginRight: '10px' }}
          >
            ยืนยัน
          </Button>
          <Button
            onClick={onClickCancel}
            variant="outlined"
            color="error"
            size="medium"
          >
            รีเซ็ต
          </Button>
        </Grid>
      </Grid>
    </form>
  );

  return (
    <Grid container>
      <Loading isLoading={isLoading} />
      <Grid item xs={12} md={12}>
        <div className="font-bold text-xl" style={{ marginLeft: '20px' }}>
          รายการรอดำเนินการ
        </div>
      </Grid>
      <Grid item xs={12} md={12}>
        {renderFilterFormPendingSuperAdmin()}
      </Grid>
      <Grid item xs={12} md={12}>
        <Paper
          sx={{
            overflow: 'hidden',
            marginTop: '20px',
            marginLeft: { xs: '10px', sm: '15px', md: '20px' },
            marginRight: { xs: '10px', sm: '15px', md: '20px' },
          }}
        >
          <TablePendingSuperAdmin
            ispendingSuperAdmin={filteredData}
            handleRequestSort={handleRequestSort}
            valueToOrderBy={valueToOrderBy}
            orderDirection={orderDirection}
            pagination={pagination}
            handlePaginationChange={handlePaginationChange}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}

export default PendingSuperAdmin;
